import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory } from 'react-router'
import Home from './containers/home/Home';
import Projects from './containers/projects/Projects';
import Content from './containers/content/Content';
import About from './containers/about/About';
import Contact from './containers/contact/Contact';
import Blog from './containers/blog/Blog';
import BlogPost from './containers/blog-post/BlogPost';
import NotFound from './containers/not-found/NotFound';
import './normalize.css';
import './grid.css';
import './animate.css';
import './index.css';

ReactDOM.render((
  <Router onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}>
    <Route path="/" component={Home} />
    <Route path="/projects/tags(/:tag)" component={Projects} />
    <Route path="/projects/:engName" component={Content} />
    <Route path="/about" component={About} />
    <Route path="/contact" component={Contact} />
    <Route path="/journal" component={Blog} />
    <Route path="/journal/:title" component={BlogPost} />
    <Route path="/notFound" component={NotFound} />
    <Route path="*" component={NotFound} />
  </Router>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js